import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const pushSupported = () =>
  typeof window !== "undefined" &&
  "serviceWorker" in navigator &&
  "PushManager" in window &&
  "Notification" in window;

export async function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return null;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    return reg;
  } catch (_e) {
    return null;
  }
}

export async function getSubscriptionState() {
  if (!pushSupported()) return { supported: false };
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  return {
    supported: true,
    permission: Notification.permission,
    subscribed: !!sub,
    endpoint: sub?.endpoint,
  };
}

export async function subscribePush() {
  if (!pushSupported()) throw new Error("Push not supported in this browser");
  const reg = await navigator.serviceWorker.ready;
  const perm = await Notification.requestPermission();
  if (perm !== "granted") throw new Error("Permission denied");
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.key) throw new Error("VAPID key not configured");
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.key),
  });
  const subJson = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: subJson.endpoint, keys: subJson.keys });
  return subJson;
}

export async function unsubscribePush() {
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const ep = sub.endpoint;
    const keys = sub.toJSON().keys || {};
    await sub.unsubscribe();
    try { await api.post("/push/unsubscribe", { endpoint: ep, keys }); } catch (_e) { /* ignore */ }
  }
}
